export const config = {
    configuration: true,
    searchList: {
        searchTxt: []
    },
    table: {
        selectBtn: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: '条码',
                prop: 'barcodeNo'
            },
            {
                label: '单据号',
                prop: 'sourceBillNo'
            },
            {
                label: '单据日期',
                prop: 'billDate'
            },
            {
                label: '生产日期',
                prop: 'prodDate'
            },
            {
                label: '校验日期',
                prop: 'checkDate'
            },
            {
                label: '产品编码',
                prop: 'itemCode'
            },
            {
                label: '产品名称',
                prop: 'itemName'
            },
            {
                label: '发货单位名称',
                prop: 'shipOrgName'
            },
            {
                label: '收货单位名称',
                prop: 'recOrgName'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
